// extracted by mini-css-extract-plugin
export default {"addonsList":"AddonsLoader_addonsList__QnlrI","list":"AddonsLoader_list__2ml3R","item":"AddonsLoader_item__LBrcU","shine":"AddonsLoader_shine__+pcgH"};